import React from "react";
import { Row, Col, Typography, Space, Card } from "antd";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const { Title, Paragraph } = Typography;

const AboutPage = () => {
  const { t } = useTranslation();
  
  return (
    <>
      <Helmet>
        <title>{t('about.title')}</title>
      </Helmet>

      {/* Hero Section */}
      <section style={{ padding: "80px 20px", textAlign: "center", background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", color: "white" }}>
        <div style={{ maxWidth: "800px", margin: "0 auto" }}>
          <Title level={1} style={{ color: "white", fontSize: "clamp(2rem, 5vw, 3.5rem)", marginBottom: "24px" }}>
            {t('about.heroTitle')}
          </Title>
          <Paragraph style={{ fontSize: "clamp(1rem, 2.5vw, 1.25rem)", color: "rgba(255,255,255,0.9)" }}>
            {t('about.heroSubtitle')}
          </Paragraph>
        </div>
      </section>

      {/* Mission Section */}
      <section style={{ padding: "80px 20px" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <Row gutter={[48, 48]} align="middle">
            <Col xs={24} lg={12}>
              <Space direction="vertical" size="large" style={{ width: "100%" }}>
                <Title level={2} style={{ fontSize: "clamp(1.5rem, 4vw, 2.5rem)" }}>
                  {t('about.ourMission')}
                </Title>
                <Paragraph style={{ fontSize: "18px", lineHeight: "1.6" }}>
                  {t('about.missionText1')}
                </Paragraph>
                <Paragraph style={{ fontSize: "18px", lineHeight: "1.6" }}>
                  {t('about.missionText2')}
                </Paragraph>
              </Space>
            </Col>
            <Col xs={24} lg={12}>
              <div style={{ textAlign: "center", fontSize: "clamp(60px, 12vw, 150px)", lineHeight: "1", padding: "20px 0" }}>🎯</div>
            </Col>
          </Row>
        </div>
      </section>

      {/* Target Audience */}
      <section style={{ padding: "80px 20px", background: "#f8f9fa" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <Title level={2} style={{ textAlign: "center", marginBottom: "60px", fontSize: "clamp(1.5rem, 4vw, 2.5rem)" }}>
            {t('about.whoIsTaskizy')}
          </Title>
          <Row gutter={[32, 32]}>
            <Col xs={24} md={12}>
              <Card style={{ height: "100%", border: "none", boxShadow: "0 4px 20px rgba(0,0,0,0.1)" }}>
                <div style={{ fontSize: "48px", marginBottom: "20px" }}>🏢</div>
                <Title level={3}>{t('about.forCompanies')}</Title>
                <Paragraph style={{ fontSize: "16px", lineHeight: "1.6" }}>
                  {t('about.forCompaniesDesc')}
                </Paragraph>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card style={{ height: "100%", border: "none", boxShadow: "0 4px 20px rgba(0,0,0,0.1)" }}>
                <div style={{ fontSize: "48px", marginBottom: "20px" }}>⏰</div>
                <Title level={3}>{t('about.forFreetime')}</Title>
                <Paragraph style={{ fontSize: "16px", lineHeight: "1.6" }}>
                  {t('about.forFreetimeDesc')}
                </Paragraph>
              </Card>
            </Col>
          </Row>
        </div>
      </section>

      {/* API Section */}
      <section style={{ padding: "80px 20px" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <Row gutter={[48, 48]} align="middle">
            <Col xs={24} lg={12}>
              <div style={{ textAlign: "center", fontSize: "clamp(60px, 12vw, 150px)", lineHeight: "1", padding: "20px 0" }}>⚡</div>
            </Col>
            <Col xs={24} lg={12}>
              <Space direction="vertical" size="large" style={{ width: "100%" }}>
                <Title level={2} style={{ fontSize: "clamp(1.5rem, 4vw, 2.5rem)" }}>
                  {t('about.taskizyAPI')}
                </Title>
                <Paragraph style={{ fontSize: "18px", lineHeight: "1.6" }}>
                  {t('about.apiDesc1')}
                </Paragraph>
                <Paragraph style={{ fontSize: "18px", lineHeight: "1.6" }}>
                  {t('about.apiDesc2')}
                </Paragraph>
              </Space>
            </Col>
          </Row>
        </div>
      </section>

      {/* Founder Section */}
      <section style={{ padding: "80px 20px", background: "#f8f9fa" }}>
        <div style={{ maxWidth: "800px", margin: "0 auto", textAlign: "center" }}>
          <Title level={2} style={{ marginBottom: "40px", fontSize: "clamp(1.5rem, 4vw, 2.5rem)" }}>
            {t('about.aboutFounder')}
          </Title>
          <Card style={{ border: "none", boxShadow: "0 4px 20px rgba(0,0,0,0.1)" }}>
            <div style={{ fontSize: "clamp(60px, 12vw, 80px)", lineHeight: "1", padding: "20px 0" }}>👨‍💻</div>
            <Paragraph style={{ fontSize: "18px", lineHeight: "1.6" }}>
              {t('about.founderDesc')}
            </Paragraph>
          </Card>
        </div>
      </section>

      {/* Contact Section */}
      <section style={{ padding: "80px 20px" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <Title level={2} style={{ textAlign: "center", marginBottom: "60px", fontSize: "clamp(1.5rem, 4vw, 2.5rem)" }}>
            {t('about.contact')}
          </Title>
          <Row gutter={[32, 32]} justify="center">
            <Col xs={24} md={12} lg={8}>
              <Card style={{ textAlign: "center", border: "none", boxShadow: "0 4px 20px rgba(0,0,0,0.1)" }}>
                <div style={{ fontSize: "48px", marginBottom: "20px" }}>📍</div>
                <Title level={4}>{t('about.address')}</Title>
                <Paragraph>
                  Taskizy<br />
                  ul. Wolności 64B<br />
                  73-200 Choszczno
                </Paragraph>
              </Card>
            </Col>
            <Col xs={24} md={12} lg={8}>
              <Card style={{ textAlign: "center", border: "none", boxShadow: "0 4px 20px rgba(0,0,0,0.1)" }}>
                <div style={{ fontSize: "48px", marginBottom: "20px" }}>📄</div>
                <Title level={4}>{t('about.companyData')}</Title>
                <Paragraph>
                  NIP: 594-153-38-20<br />
                  REGON: 320305252<br />
                  {t('about.vatPayer')}
                </Paragraph>
              </Card>
            </Col>
            <Col xs={24} md={12} lg={8}>
              <Card style={{ textAlign: "center", border: "none", boxShadow: "0 4px 20px rgba(0,0,0,0.1)" }}>
                <div style={{ fontSize: "48px", marginBottom: "20px" }}>📞</div>
                <Title level={4}>{t('about.contact')}</Title>
                <Paragraph>
                  kontakt@postpay.pl<br />
                  +48 530 858 861
                </Paragraph>
              </Card>
            </Col>
          </Row>
        </div>
      </section>
    </>
  );
};

export default AboutPage;